import StatusBarWrapper from "@components/Layouts/StatusBar/StatusBarWrapper";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useIsRevision } from "@ext/git/actions/Revisions/logic/hooks/useIsRevision";
import t from "@ext/localization/locale/translate";
import { Indicator } from "@ui-kit/Indicator";

interface ShowRevisionsTabProps {
	isShow: boolean;
	setShow: (show: boolean) => void;
}

const ShowRevisionsTab = (props: ShowRevisionsTabProps) => {
	const { isShow, setShow } = props;
	const { isNext } = usePlatform();
	const isRevision = useIsRevision();
	if (isNext) return null;

	return (
		<div className="relative">
			{isRevision && (
				<Indicator
					className="absolute right-0.5 top-0.5 bg-status-error rounded-full pointer-events-none"
					size="xs"
				/>
			)}
			<StatusBarWrapper
				additionalStyles={{ height: "100%" }}
				dataQa="qa-revisions-tab"
				iconCode="history"
				iconStrokeWidth="1.6"
				iconStyle={isShow ? { color: "var(--color-primary)" } : { color: "white" }}
				isShow={isShow}
				onClick={() => setShow(!isShow)}
				tooltipText={t("git.revisions.compare-button")}
			/>
		</div>
	);
};

export default ShowRevisionsTab;
